export const DRIVER_REPORT_OPTIONS = [
    'ABS DRIVERS',
    'PA6 DRIVERS',
    'PA66 DRIVERS',
    'PC DRIVERS',
    'PE DRIVERS',
    'PET DRIVERS',
    'PP DRIVERS',
    'PS DRIVERS',
    'PVC DRIVERS',
];
// Access Levels
export const ACCESS_LEVELS = {
    BASE: 1,
    COMPOUND: 2,
    PRIME: 3,
    EMPLOYEE: 4,
};
// Data Files Mapping
export const DATA_FILES = {
    CAPRO: 'caproData.json',
    PETCHEM: 'petchemData.json',
    CHLORINE: 'chlorineData.json',
    DRIVERS: 'driverData.json',
    DRIVER_CHARTS: 'driverCharts.json',
    DRIVER_PRICE_CHANGES: 'driverPriceChanges.json',
    CHEMORBIS: 'chemOrbisData.json',
    PETMASTERPRICING: 'petMasterPricingData.json',
    CONTRACTS: 'contractsData.json',
    REFINERY_RATES: 'refineryRatesData.json',
    NEWS_DATA: 'news_agg.json',
    DIESEL_PRICES: 'dieselPricesData.json',
    // ACC Monthly Snapshot data files
    ACC_PE: 'v_acc_pe.json',
    ACC_PP: 'v_acc_pp.json',
    ACC_PS: 'v_acc_ps.json',
    ACC_PVC: 'v_acc_pvc.json',
    ACC_PE_FINAL: 'v_acc_pe_final.json',
    ACC_PP_FINAL: 'v_acc_pp_final.json',
    ACC_PS_FINAL: 'v_acc_ps_final.json',
    ACC_PVC_FINAL: 'v_acc_pvc_final.json',
    FAIR_PRICE: 'fairPriceData.json',
    FORECAST: 'forecastData.json',
    FORECAST_COMMENTARY: 'forecastCommentary.json',
    EIA_FORECAST: 'vw_eia_steo_forecast.json',
    EMAIL_BULLETS: 'emailBulletsData.json',
    FREIGHTOS: 'freightosData.json',
    // PE Market Intel data files
    MI_PE_INVENTORY: 'pe/inventoryMetrics.json',
    MI_PE_PRODUCTION: 'pe/productionCapacity.json',
    MI_PE_MARKETS: 'pe/markets.json',
    MI_PE_RATES: 'pe/rates.json',
    MI_PE_USITC: 'pe/usitcTrade.json',
    PE_COMMENTARY: 'pe/commentary.json',
    HDPE_COMMENTARY: 'pe/hdpeCommentary.json',
    LDPE_COMMENTARY: 'pe/ldpeCommentary.json',
    LLDPE_COMMENTARY: 'pe/lldpeCommentary.json',
    MI_PP_RATES: 'pp/rates.json',
    MI_PP_INVENTORY: 'pp/inventoryMetrics.json',
    MI_PS_RATES: 'ps/rates.json',
    MI_PS_INVENTORY: 'ps/inventoryMetrics.json',
    MI_PVC_RATES: 'pvc/rates.json',
    MI_PVC_INVENTORY: 'pvc/inventoryMetrics.json',
    MI_PET_RATES: 'pet/rates.json',
    MI_PP_USITC: 'pp/usitcTrade.json',
    MI_PS_USITC: 'ps/usitcTrade.json',
    MI_PVC_USITC: 'pvc/usitcTrade.json',
    MI_PET_USITC: 'pet/usitcTrade.json',
};
export const API_PREFIX = {
    USER: '/user',
    GATEWAY: '/gateway',
    GATEWAY_USER: '/gateway/user',
    SYNAPSE: '/gateway/synapse',
    COMPANY: '/company',
    ADMIN: '/admin',
    DEVOPS: '/devops',
    ANALYTICS: '/analytics',
};
// API Routes Mapping
export const API_ROUTES = {
    CLIENT_DATA: `${API_PREFIX.SYNAPSE}/m/client-data`,
    CAPRO: `${API_PREFIX.SYNAPSE}/w/capro`,
    PETCHEM: `${API_PREFIX.SYNAPSE}/d/rti-petchem`,
    CHLORINE: `${API_PREFIX.SYNAPSE}/m/chlorine`,
    CONTRACTS: `${API_PREFIX.SYNAPSE}/d/contracts`,
    PET_MASTER_PRICING: `${API_PREFIX.SYNAPSE}/w/pet-master-pricing`,
    REFINERY_RATES: `${API_PREFIX.SYNAPSE}/w/refinery-rates`,
    CHEM_ORBIS: `${API_PREFIX.SYNAPSE}/w/orbis-price-wizard`,
    DRIVER_COMMENTARY: `${API_PREFIX.SYNAPSE}/w/driver-commentary-data`,
    DRIVER_PRICE_CHANGES: `${API_PREFIX.SYNAPSE}/w/driver-price-changes`,
    DRIVER_PRICE_CHANGES_PENDING: `${API_PREFIX.SYNAPSE}/w/driver-price-changes/pending`,
    DRIVER_PRICE_CHANGES_COMMIT: `${API_PREFIX.SYNAPSE}/w/driver-price-changes/commit`,
    DRIVER_PRICE_CHANGES_CANCEL: `${API_PREFIX.SYNAPSE}/w/driver-price-changes/cancel`,
    NEWS: `${API_PREFIX.SYNAPSE}/w/news`,
    EMAIL_BULLETS: `${API_PREFIX.SYNAPSE}/o/commentary/bullets`,
    FREIGHTOS: `${API_PREFIX.SYNAPSE}/o/freightos`,
    AUTHORIZE: `${API_PREFIX.USER}/authorize`,
    FREE_TRIAL_SIGNUP: `${API_PREFIX.USER}/free-trial/signup`,
    FREE_TRIAL_DOMAINS: `${API_PREFIX.USER}/free-trial/domains`,
    FREE_TRIAL_CHECK_DOMAIN: `${API_PREFIX.USER}/free-trial/check-domain`,
    VERIFY_EMAIL: `${API_PREFIX.USER}/verify-email`,
    RESEND_VERIFICATION: `${API_PREFIX.USER}/resend-verification`,
    REPORT_USER: `${API_PREFIX.GATEWAY}/report/user/`,
    MEMBERSHIP_ALL: `${API_PREFIX.GATEWAY}/membership/all`,
    USER_ACCESS_REQUEST: `${API_PREFIX.GATEWAY}/user-access-request`,
    USER_ACCESS_REQUEST_BULK: `${API_PREFIX.GATEWAY}/user-access-request/bulk`,
    USER_ACCESS_REQUEST_RESOLVE: `${API_PREFIX.GATEWAY}/user-access-request/resolve/`,
    CLIENT_LEAD: `${API_PREFIX.GATEWAY}/client-lead/`,
    CLIENT_LEAD_ALL: `${API_PREFIX.GATEWAY}/client-lead/all`,
    REPORT_ALL: `${API_PREFIX.GATEWAY}/report/all`,
    REPORT: `${API_PREFIX.GATEWAY}/report/`,
    ADMIN_REPORTS: `${API_PREFIX.GATEWAY}/admin/reports`,
    SAVE_DATA: `${API_PREFIX.GATEWAY}/save-data`,
    UTILS_REPORT_OPTIONS: `${API_PREFIX.GATEWAY}/utils/report-options`,
    USER_SESSION: `${API_PREFIX.GATEWAY}/user-session`,
    USER_SESSION_CLOSE: `${API_PREFIX.GATEWAY}/user-session/close`,
    CACHE_SAVE: `${API_PREFIX.GATEWAY}/cache/save`,
    CACHE_READ: `${API_PREFIX.GATEWAY}/cache/read`,
    CACHE_VERSION: `${API_PREFIX.GATEWAY}/cache/version`,
    DRIVER_CHARTS_CONFIG: `${API_PREFIX.GATEWAY}/config/driver-charts`,
    PASSWORD_UPDATE: `${API_PREFIX.USER}/password/update`,
    ADMIN_RESET_PASSWORD: `${API_PREFIX.USER}/admin/reset-password`,
    UPDATE_PROFILE: `${API_PREFIX.USER}/profile/update`,
    TERMS_ACCEPT: `${API_PREFIX.USER}/terms-of-use/accept`,
    USER_ALL: `${API_PREFIX.USER}/all`,
    USER_IMPERSONATE: `${API_PREFIX.USER}/impersonate`,
    USER_HS_ACTIVITY: `${API_PREFIX.USER}/hs-activity/`,
    USER_ACTIVITY: `${API_PREFIX.USER}/activity/`,
    USER_FROM_CLIENT: `${API_PREFIX.USER}/from-client/`,
    USER_PREFERENCES: `${API_PREFIX.USER}/preferences/`,
    USER_ROOT: `${API_PREFIX.USER}/`,
    USER_PASSKEY_BEGIN: `${API_PREFIX.USER}/passkey/begin`,
    USER_PASSKEY_FINISH: `${API_PREFIX.USER}/passkey/finish`,
    USER_PASSKEY_REGISTER_BEGIN: `${API_PREFIX.USER}/passkey/register/begin`,
    USER_PASSKEY_REGISTER_FINISH: `${API_PREFIX.USER}/passkey/register/finish`,
    USER_PASSKEYS_LIST: `${API_PREFIX.USER}/passkeys`,
    USER_PASSKEYS_DELETE: `${API_PREFIX.USER}/passkeys`,
    FREE_EMAIL_DOMAINS: `${API_PREFIX.GATEWAY}/config/free-email-domains`,
    // ACC Monthly Snapshot routes
    ACC_PE: `${API_PREFIX.SYNAPSE}/m/v_acc_pe`,
    ACC_PP: `${API_PREFIX.SYNAPSE}/m/v_acc_pp`,
    ACC_PS: `${API_PREFIX.SYNAPSE}/m/v_acc_ps`,
    ACC_PVC: `${API_PREFIX.SYNAPSE}/m/v_acc_pvc`,
    ACC_PE_FINAL: `${API_PREFIX.SYNAPSE}/m/v_acc_pe_final`,
    ACC_PP_FINAL: `${API_PREFIX.SYNAPSE}/m/v_acc_pp_final`,
    ACC_PS_FINAL: `${API_PREFIX.SYNAPSE}/m/v_acc_ps_final`,
    ACC_PVC_FINAL: `${API_PREFIX.SYNAPSE}/m/v_acc_pvc_final`,
    // Pricing Forecast routes
    FAIR_PRICE: `${API_PREFIX.SYNAPSE}/m/forecasts/fair-price-index/date-range`,
    FORECAST: `${API_PREFIX.SYNAPSE}/m/forecasts/graph-data/all`,
    FORECAST_COMMENTARY: `${API_PREFIX.SYNAPSE}/m/forecasts/commentary-data/active`,
    // EIA Forecast routes
    EIA_FORECAST: `${API_PREFIX.SYNAPSE}/m/eia/forecast`,
    // Global Data Refresh Coordination routes
    GLOBAL_REFRESH_STATUS: `${API_PREFIX.GATEWAY}/global-refresh/status`,
    GLOBAL_REFRESH_REQUEST: `${API_PREFIX.GATEWAY}/global-refresh/request`,
    GLOBAL_REFRESH_CHECK: `${API_PREFIX.GATEWAY}/global-refresh/check-and-trigger`,
    GLOBAL_REFRESH_RESET: `${API_PREFIX.GATEWAY}/global-refresh/reset`,
    GLOBAL_REFRESH_SELECTIVE: `${API_PREFIX.GATEWAY}/global-refresh/selective`,
    // Password Reset routes
    PASSWORD_RESET_REQUEST: `${API_PREFIX.GATEWAY}/password-reset/request`,
    PASSWORD_RESET_VERIFY: `${API_PREFIX.GATEWAY}/password-reset/verify`,
    PASSWORD_RESET_COMPLETE: `${API_PREFIX.GATEWAY}/password-reset/complete`,
    // Microsoft/PowerBI utilities
    UTILS_MICROSOFT_POWERBI_ACQUIRE_ACCESS_TOKEN: `${API_PREFIX.GATEWAY}/utils/microsoft/powerbi/acquire-access-token`,
    // Daily Spot & Contracts Data Entry
    DAILY_SPOT: `${API_PREFIX.SYNAPSE}/d/daily-spot-data`,
    DAILY_SPOT_PENDING: `${API_PREFIX.SYNAPSE}/d/daily-spot-data/pending`,
    DAILY_SPOT_COMMIT: `${API_PREFIX.SYNAPSE}/d/daily-spot-data/commit`,
    DAILY_SPOT_CANCEL: `${API_PREFIX.SYNAPSE}/d/daily-spot-data/cancel`,
    DAILY_CONTRACTS: `${API_PREFIX.SYNAPSE}/d/daily-contracts-data`,
    DAILY_CONTRACTS_PENDING: `${API_PREFIX.SYNAPSE}/d/daily-contracts-data/pending`,
    DAILY_CONTRACTS_COMMIT: `${API_PREFIX.SYNAPSE}/d/daily-contracts-data/commit`,
    DAILY_CONTRACTS_CANCEL: `${API_PREFIX.SYNAPSE}/d/daily-contracts-data/cancel`,
    // Commentary Data Management routes
    COMMENTARY_DRIVERS: `${API_PREFIX.SYNAPSE}/w/driver-commentary-data`,
    COMMENTARY_DRIVERS_COUNT: `${API_PREFIX.SYNAPSE}/w/driver-commentary-data/count`,
    COMMENTARY_DRIVERS_LATEST: `${API_PREFIX.SYNAPSE}/w/driver-commentary-data/latest-update-time`,
    COMMENTARY_DRIVERS_STAGING: `${API_PREFIX.SYNAPSE}/w/drivers/commentary-data`,
    COMMENTARY_DRIVERS_PENDING: `${API_PREFIX.SYNAPSE}/w/drivers/commentary-data/pending`,
    COMMENTARY_DRIVERS_COMMIT: `${API_PREFIX.SYNAPSE}/w/drivers/commentary-data/commit`,
    COMMENTARY_DRIVERS_CANCEL: `${API_PREFIX.SYNAPSE}/w/drivers/commentary-data/cancel`,
    COMMENTARY_PE: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data`,
    COMMENTARY_PE_COUNT: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data/count`,
    COMMENTARY_PE_LATEST: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data/latest-update-time`,
    COMMENTARY_PE_PENDING: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data/pending`,
    COMMENTARY_PE_COMMIT: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data/commit`,
    COMMENTARY_PE_CANCEL: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data/cancel`,
    COMMENTARY_PE_CANCEL_ONE: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data/cancel`,
    COMMENTARY_PE_FINAL: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data-final`,
    COMMENTARY_PE_FINAL_PENDING: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data-final/pending`,
    COMMENTARY_PE_FINAL_COMMIT: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data-final/commit`,
    COMMENTARY_PE_FINAL_CANCEL: `${API_PREFIX.SYNAPSE}/m/peacc-commentary-data-final/cancel`,
    COMMENTARY_PP: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data`,
    COMMENTARY_PP_COUNT: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data/count`,
    COMMENTARY_PP_LATEST: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data/latest-update-time`,
    COMMENTARY_PP_PENDING: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data/pending`,
    COMMENTARY_PP_COMMIT: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data/commit`,
    COMMENTARY_PP_CANCEL: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data/cancel`,
    COMMENTARY_PP_CANCEL_ONE: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data/cancel`,
    COMMENTARY_PP_FINAL: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data-final`,
    COMMENTARY_PP_FINAL_PENDING: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data-final/pending`,
    COMMENTARY_PP_FINAL_COMMIT: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data-final/commit`,
    COMMENTARY_PP_FINAL_CANCEL: `${API_PREFIX.SYNAPSE}/m/ppacc-commentary-data-final/cancel`,
    COMMENTARY_PS: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data`,
    COMMENTARY_PS_COUNT: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data/count`,
    COMMENTARY_PS_LATEST: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data/latest-update-time`,
    COMMENTARY_PS_PENDING: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data/pending`,
    COMMENTARY_PS_COMMIT: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data/commit`,
    COMMENTARY_PS_CANCEL: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data/cancel`,
    COMMENTARY_PS_CANCEL_ONE: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data/cancel`,
    COMMENTARY_PS_FINAL: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data-final`,
    COMMENTARY_PS_FINAL_PENDING: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data-final/pending`,
    COMMENTARY_PS_FINAL_COMMIT: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data-final/commit`,
    COMMENTARY_PS_FINAL_CANCEL: `${API_PREFIX.SYNAPSE}/m/psacc-commentary-data-final/cancel`,
    COMMENTARY_PVC: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data`,
    COMMENTARY_PVC_COUNT: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data/count`,
    COMMENTARY_PVC_LATEST: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data/latest-update-time`,
    COMMENTARY_PVC_PENDING: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data/pending`,
    COMMENTARY_PVC_COMMIT: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data/commit`,
    COMMENTARY_PVC_CANCEL: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data/cancel`,
    COMMENTARY_PVC_CANCEL_ONE: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data/cancel`,
    COMMENTARY_PVC_FINAL: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data-final`,
    COMMENTARY_PVC_FINAL_PENDING: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data-final/pending`,
    COMMENTARY_PVC_FINAL_COMMIT: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data-final/commit`,
    COMMENTARY_PVC_FINAL_CANCEL: `${API_PREFIX.SYNAPSE}/m/pvcacc-commentary-data-final/cancel`,
    COMMENTARY_FORECAST: `${API_PREFIX.SYNAPSE}/m/forecasts/commentary-data`,
    COMMENTARY_FORECAST_COUNT: `${API_PREFIX.SYNAPSE}/m/forecasts/commentary-data/count`,
    COMMENTARY_FORECAST_PENDING: `${API_PREFIX.SYNAPSE}/m/forecasts/commentary-data/pending`,
    COMMENTARY_FORECAST_COMMIT: `${API_PREFIX.SYNAPSE}/m/forecasts/commentary-data/commit`,
    COMMENTARY_FORECAST_CANCEL: `${API_PREFIX.SYNAPSE}/m/forecasts/commentary-data/cancel`,
    COMMIT_CHANGES: `${API_PREFIX.SYNAPSE}/m/commit-changes`,
    BILLING_PLANS: `${API_PREFIX.GATEWAY}/billing/plans`,
    BILLING_CHECKOUT: `${API_PREFIX.GATEWAY}/billing/checkout`,
    BILLING_SUBSCRIPTION: `${API_PREFIX.GATEWAY}/billing/subscription`,
    BILLING_SUBSCRIPTION_SYNC: `${API_PREFIX.GATEWAY}/billing/subscription/sync`,
    BILLING_CHECKOUT_CONFIRM: `${API_PREFIX.GATEWAY}/billing/checkout/confirm`,
    ADMIN_SUBSCRIPTIONS: `${API_PREFIX.GATEWAY}/billing/admin/subscriptions`,
    ADMIN_SUBSCRIPTION_AUDIT: `${API_PREFIX.GATEWAY}/billing/admin/subscription-audit`,
    BILLING_SUBSCRIPTION_CANCEL: `${API_PREFIX.GATEWAY}/billing/subscription/cancel`,
    BILLING_SUBSCRIPTION_PAUSE: `${API_PREFIX.GATEWAY}/billing/subscription/pause`,
    BILLING_SUBSCRIPTION_RESUME: `${API_PREFIX.GATEWAY}/billing/subscription/resume`,
    BILLING_INVOICES: `${API_PREFIX.GATEWAY}/billing/invoices`,
    BILLING_UPDATE_CARD_LINK: `${API_PREFIX.GATEWAY}/billing/payment-method/update-link`,
    BILLING_CONTACT: `${API_PREFIX.GATEWAY}/billing/contact`,
    DRIVERS_PDF_CHECK_CACHE: `${API_PREFIX.GATEWAY}/api/drivers/cached-pdf-exists`,
    DRIVERS_PDF_DOWNLOAD: `${API_PREFIX.GATEWAY}/api/drivers/download-cached-pdf`,
    DRIVERS_PDF_SAVE: `${API_PREFIX.GATEWAY}/api/drivers/save-pdf`,
    PETCHEM_FILE_CHECK_CACHE: `${API_PREFIX.GATEWAY}/api/petchem/cached-file-exists`,
    PETCHEM_FILE_DOWNLOAD: `${API_PREFIX.GATEWAY}/api/petchem/download-cached-file`,
    PETCHEM_FILE_SAVE: `${API_PREFIX.GATEWAY}/api/petchem/save-file`,
    ACC_PDF_CHECK_CACHE: `${API_PREFIX.GATEWAY}/api/acc/cached-pdf-exists`,
    ACC_PDF_DOWNLOAD: `${API_PREFIX.GATEWAY}/api/acc/download-cached-pdf`,
    ACC_PDF_SAVE: `${API_PREFIX.GATEWAY}/api/acc/save-pdf`,
    // Company management
    COMPANY: `${API_PREFIX.COMPANY}/`,
    COMPANY_MEMBERS: `${API_PREFIX.COMPANY}/members`,
    COMPANY_DOMAINS: `${API_PREFIX.COMPANY}/domains`,
    // Admin
    ADMIN_COMPANIES: `${API_PREFIX.ADMIN}/companies`,
    ADMIN_PARENT_GROUPS: `${API_PREFIX.ADMIN}/parent-groups`,
    ADMIN_SYNC_ALL_HUBSPOT: `${API_PREFIX.ADMIN}/sync-all-hubspot`,
    ADMIN_SYNC_ALL_HUBSPOT_STATUS: `${API_PREFIX.ADMIN}/sync-all-hubspot/status`,
    ADMIN_HUBSPOT_ID_SCAN: `${API_PREFIX.ADMIN}/companies/hubspot-ids/scan`,
    ADMIN_HUBSPOT_ID_APPLY: `${API_PREFIX.ADMIN}/companies/hubspot-ids/apply`,
    DEVOPS_CONFIG: `${API_PREFIX.DEVOPS}/config`,
    DEVOPS_ASSIGNEES: `${API_PREFIX.DEVOPS}/assignees`,
    DEVOPS_REQUESTERS: `${API_PREFIX.DEVOPS}/requesters`,
    DEVOPS_EPICS: `${API_PREFIX.DEVOPS}/epics`,
    DEVOPS_SPRINTS: `${API_PREFIX.DEVOPS}/sprints`,
    DEVOPS_ATTACHMENTS: `${API_PREFIX.DEVOPS}/attachments`,
    DEVOPS_TICKETS: `${API_PREFIX.DEVOPS}/tickets`,
    ANALYTICS_CONFIG: `${API_PREFIX.ANALYTICS}/config`,
    ANALYTICS_OVERVIEW: `${API_PREFIX.ANALYTICS}/overview`,
    ANALYTICS_CLIENT_HEALTH: `${API_PREFIX.ANALYTICS}/client-health`,
    // User Notifications (served from gateway.py → /gateway/user/*)
    USER_NOTIFICATIONS: `${API_PREFIX.GATEWAY_USER}/notifications`,
    USER_NOTIFICATIONS_SYNC: `${API_PREFIX.GATEWAY_USER}/notifications/sync-hubspot`,
    USER_NOTIFICATIONS_AUDIT: `${API_PREFIX.GATEWAY_USER}/notifications/audit`,
    USER_DATA_NOTIFICATIONS: `${API_PREFIX.GATEWAY_USER}/data-notifications/preferences`,
    USER_DATA_NOTIFICATIONS_INBOX: `${API_PREFIX.GATEWAY_USER}/data-notifications/inbox`,
    USER_HOME_LAYOUT: `${API_PREFIX.GATEWAY_USER}/home-layout`,
    USER_ADMIN_MENU: `${API_PREFIX.GATEWAY_USER}/admin-menu`,
    // Admin — Available Subscriptions
    ADMIN_AVAILABLE_SUBSCRIPTIONS: `${API_PREFIX.GATEWAY}/admin/available-subscriptions`,
    ADMIN_TEST_NOTIFICATION: `${API_PREFIX.ADMIN}/notifications/test`,
    // Admin — Market Links & Promo Codes
    ADMIN_MARKET_LINKS: `${API_PREFIX.GATEWAY}/admin/market-links`,
    ADMIN_PROMO_CODES: `${API_PREFIX.GATEWAY}/admin/promo-codes`,
    BILLING_PROMO_VALIDATE: `${API_PREFIX.GATEWAY}/billing/promo/validate`,
    // Feeds / Email Manager
    FEEDS_STATE: `${API_PREFIX.GATEWAY}/feeds/state`,
    FEEDS_TRIGGER: `${API_PREFIX.GATEWAY}/feeds/trigger`,
    FEEDS_PREVIEW: `${API_PREFIX.GATEWAY}/feeds/preview`,
    FEEDS_TEST_SEND: `${API_PREFIX.GATEWAY}/feeds/test-send`,
    FEEDS_RSS_REFRESH: `${API_PREFIX.ADMIN}/rss/refresh`,
    FEEDS_REFRESH_RSS_SINGLE: `${API_PREFIX.GATEWAY}/feeds/refresh-rss`,
    // Feature Flags
    FEATURE_FLAGS: `${API_PREFIX.GATEWAY}/feature-flags`,
    ADMIN_FEATURE_FLAGS: `${API_PREFIX.GATEWAY}/admin/feature-flags`,
    // Interactive demo
    DEMO_SNAPSHOT: `${API_PREFIX.GATEWAY}/demo/snapshot`,
    DEMO_ADMIN_SNAPSHOT: `${API_PREFIX.GATEWAY}/demo/admin/snapshot`,
    DEMO_ADMIN_CAPTURE: `${API_PREFIX.GATEWAY}/demo/admin/capture`,
    DEMO_ADMIN_ANALYTICS: `${API_PREFIX.GATEWAY}/demo/admin/analytics`,
    // AI Summary
    AI_SNAPSHOT_SUMMARY: `${API_PREFIX.GATEWAY}/ai/summary`,
    AI_INSIGHTS: `${API_PREFIX.GATEWAY}/ai/insights`,
    AI_PROMPT_TEMPLATE: `${API_PREFIX.GATEWAY}/ai/prompt-template`,
    AI_INSIGHTS_REGENERATE: `${API_PREFIX.GATEWAY}/ai/insights`,
    AI_SUMMARY_REGENERATE: `${API_PREFIX.GATEWAY}/ai/summary`,
    // Nav Items
    NAV_ITEMS: `${API_PREFIX.GATEWAY}/nav-items`,
    ADMIN_NAV_ITEMS: `${API_PREFIX.GATEWAY}/admin/nav-items`,
};
export const POLYMER_LABELS = {
    HDPEBlowMLDG: 'HDPE Blow Molding',
    HDPEHMWFilm: 'HDPE HMW Film',
    HDPEINJ: 'HDPE INJ',
    LDPEGPFilm: 'LDPE GP Film',
    LLDPEButene: 'LLDPE Butene',
    LLDPEHexene: 'LLDPE Hexene',
    PPHomo: 'PP Homopolymer',
    PPCopolymerImpact: 'PP Copolymer Impact',
    PPCopolymerRandom: 'PP Copolymer Random',
    PVC: 'PVC',
    PETFormula: 'PET',
    GPPS: 'GPPS',
    HIPS: 'HIPS'
};
// Feature Flags
export const FEATURE_FLAG_VISIBILITY = ['none', 'admin', 'employee', 'prime', 'compound', 'all'];
//# sourceMappingURL=index.js.map